import React from 'react';
import { Switch } from 'react-router-dom';

import OrganizationsManagement from '../../components/OrganizationsManagement';
import SAUsersList from '../../components/SAUsersList';
import styles from '../Layout/Layout.module.scss';
import ProtectedRoute from '../ProtectedRoute';
import { PATHS } from '../../enums/PATHS';
import { ROLES } from '../../enums/ROLES';
import Header from '../Layout/Header';
import S3StorageDetails from '../../components/OrganizationsManagement/S3StorageDetails';

const SuperAdminRoutes = () => {
  return (
    <Switch>
      <>
        <div className={styles.adminView}>
          <Header />
          <div className={styles.container}>
            <ProtectedRoute
              roles={[ROLES.SUPER_ADMIN]}
              component={S3StorageDetails}
              path={PATHS.SA_ORGANIZATION_STORAGE.path}
              exact={PATHS.SA_ORGANIZATION_STORAGE.exact}
            />
            <ProtectedRoute
              roles={[ROLES.SUPER_ADMIN]}
              component={SAUsersList}
              path={PATHS.SA_USERS_LIST.path}
              exact={PATHS.SA_USERS_LIST.exact}
            />
            <ProtectedRoute roles={[ROLES.SUPER_ADMIN]} component={OrganizationsManagement} exact path={PATHS.ADMIN_PAGE.path} />
          </div>
        </div>
      </>
    </Switch>
  );
};

export default SuperAdminRoutes;
